import { ThemeStrokeSVG } from './DebugTree.styles';

export function CopyIcon({ onClick }) {
  return (
    <ThemeStrokeSVG
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M14.4 6.975H8.325a1.35 1.35 0 00-1.35 1.35V14.4c0 .745.604 1.35 1.35 1.35H14.4a1.35 1.35 0 001.35-1.35V8.325a1.35 1.35 0 00-1.35-1.35z"
      ></path>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M4.275 11.025H3.6a1.35 1.35 0 01-1.35-1.35V3.6A1.35 1.35 0 013.6 2.25h6.075a1.35 1.35 0 011.35 1.35v.675"
      ></path>
    </ThemeStrokeSVG>
  );
}
